import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { CLIENT_RESET_PASSWORD, CLIENT_RESET_PASSWORD_SUCCESS, CLIENT_RESET_PASSWORD_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* clientResetPassword({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/v1/reset-password`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        'Project-Code': 'ADMIN_ACCESS',
        'X-Requested-By': 'one-admin',
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CLIENT_RESET_PASSWORD_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CLIENT_RESET_PASSWORD_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: CLIENT_RESET_PASSWORD_ERROR, payload: error });
  }
}

export function* watchClientResetPassword() {
  yield takeEvery(CLIENT_RESET_PASSWORD, clientResetPassword);
}

function* clientResetPasswordSaga() {
  yield all([fork(watchClientResetPassword)]);
}

export default clientResetPasswordSaga;
